export default __webpack_public_path__ + "static/media/aboutme.e3ad1e59.webp";